// extracted by mini-css-extract-plugin
export default {"loaderContainer":"persistLogin_loaderContainer__0q7RB"};